export const Documents = () => {
	return (
		<section className="container pb-32">
			<h2 className="md:text-3xl text-2xl font-bold">Zveřejňované dokumenty</h2>
			<p className="text-sm font-thin text-center pt-10">Zatím prázdné</p>
		</section>
	);
};
